const domain_queue = {
	description: "Omschrijving domeinnaam wachtrij.",

	/* --------------------------------- FILTER --------------------------------- */
	filter: {
		in_queue_only: {
			label: "Alleen actieve wachtrij",
			tooltip:
				"Wanneer deze optie aanstaat worden alleen de statussen getoond die momenteel aandacht nodig hebben en in de wachtrij zitten. Dit zijn de statussen 'in_progress' en 'error'.",
		},
		reset_button: "Reset",
		search_placeholder: "Zoek naar domeinnamen",
		status: null, // We're using status from table object below
	},

	/* ---------------------------------- TABLE --------------------------------- */
	table: {
		// DIALOG ERROR LOG
		dialog_error_log: {
			description:
				"Bekijk hieronder de error log voor de aanvraag van <strong>{{domain_name}}</strong>.",
			empty: "Voor dit domein zijn er nog geen logs aangetroffen.",
			table: {
				header: {
					created_at: "Tijdstip log",
					description: "Log omschrijving",
					id: "#",
					username: "Gebruikersnaam",
				},
			},
			title: "Domeinnaam wachtrij log - {{domain_name}}",
		},

		// DIALOG IN PROGESS
		dialog_in_progress: {
			description:
				"Weet je zeker dat je domeinnaam <strong>{{domain_name}}</strong> nogmaals op 'in afwachting' wil zetten? Hiermee zal de wachtrij proberen om nogmaals het domein te registreren.",
			on_success: "De domeinnaam is succesvol op de status 'in afwachting' gezet.",
			title: "Domeinnaam markeren als 'In afwachting",
		},

		// DIALOG OBSOLETE
		dialog_obsolete: {
			debtor_send_mail: "Bevestiging van reden naar debiteur mailen",
			description:
				"Geef hieronder een reden op waarvoor <strong>{{domain_name}}</strong> als verouderd gemarkeerd wordt.",
			on_success:
				"Domeinnaam <strong>{{domain_name}}</strong> succesvol als 'verouderd' gemarkeerd.",
			reason: {
				label: "Omschrijving",
				language: "Communicatie taal debiteur:",
				language_list: {
					de: "Duits",
					en: "Engels",
					nl: "Nederlands",
				},
				placeholder:
					"Omschrijf hier de reden tot annulering. Het handigst is om deze in de voorkeurstaal van de debiteur te schrijven.",
			},
			reason_select: {
				label: "Selecteer een reden",
				list: {
					cancelled_by_debtor: "Geannuleerd door debiteur",
					in_use: "Domeinnaam bezet",
					insufficient_domain_owner_data_provided: "Onvoldoende domeinhouder gegevens aangeleverd",
					invalid_request_spam: "Ongeldige aanvraag (spam)",
					local_presence_required: "Local presence vereist",
					other: "Anders, namelijk",
					premium: "Premium domeinnaam",
				},
				reason_list: {
					de: {
						cancelled_by_debtor:
							"Die Registrierung des Domainnamens wurde vom ursprünglichen Eigentümer oder Schuldner aufgrund eines Zahlungsproblems oder einer freiwilligen Stornierung storniert.",
						in_use:
							"Der Domainname ist bereits registriert und wird von einer anderen Partei verwendet.",
						insufficient_domain_owner_data_provided:
							"Die Registrierung wurde abgelehnt, weil nicht genügend Daten des Domaininhabers bereitgestellt wurden.",
						invalid_request_spam:
							"Die Anfrage ist ungültig, da sie als Spam oder Betrug identifiziert wurde.",
						local_presence_required:
							"Für die Registrierung ist eine lokale Präsenz oder Vertretung erforderlich, die nicht erfüllt wurde.",
						other: "",
						premium:
							"Der Domainname gilt als Premium-Domain und ist daher teurer als normale Domains.",
					},
					en: {
						cancelled_by_debtor:
							"The registration of the domain name was cancelled by the original owner or debtor due to a payment issue or voluntary cancellation.",
						in_use: "The domain name is already registered and in use by another party.",
						insufficient_domain_owner_data_provided:
							"The registration was rejected because insufficient domain owner data was provided.",
						invalid_request_spam:
							"The request is invalid as it has been identified as spam or fraud.",
						local_presence_required:
							"The registration required local presence or representation, which was not met.",
						other: "",
						premium:
							"The domain name is considered a premium domain and is therefore more expensive than regular domains.",
					},
					nl: {
						cancelled_by_debtor:
							"De registratie van de domeinnaam is geannuleerd door de oorspronkelijke eigenaar of debiteur vanwege een betalingsprobleem of vrijwillige annulering.",
						in_use: "De domeinnaam is al geregistreerd en in gebruik door een andere partij.",
						insufficient_domain_owner_data_provided:
							"De registratie is afgewezen omdat er onvoldoende gegevens van de domeinhouder zijn aangeleverd.",
						invalid_request_spam:
							"De aanvraag is ongeldig omdat deze is geïdentificeerd als spam of fraude.",
						local_presence_required:
							"De registratie vereiste lokale aanwezigheid of vertegenwoordiging, wat niet is voldaan.",
						other: "",
						premium:
							"De domeinnaam wordt beschouwd als een premium domeinnaam en is daarom duurder dan normale domeinen.",
					},
				},
			},
			title: "Domein markeren als 'verouderd'.",
		},
		empty: "Geen resultaten gevonden met het huidige zoekfilter",
		header: {
			attempts_count: "Aantal pogingen",
			debtor_code: "Debiteurnummer",
			id: "#",
			last_checked: "Laatst gecontroleerd",
			name: "Domeinnaam",
			nameservers: "Gebruikte nameservers",
			relation: "Relatie",
			status: "Domeinstatus",
		},
		menu: {
			log_view: "Logs bekijken",
			make_in_progress: "Domeinnaam markeren als 'In afwachting'.",
			make_obsolete: "Domeinnaam markeren als 'verouderd'.",
		},
		status: {
			active: "Actief",
			all: "Alle statussen",
			cancellation_pending: "Annulering in behandeling",
			cancelled: "Opgezegd",
			error: "Error",
			in_progress: "In afwachting",
			obsolete: "Verouderd",
		},
	},
	/* --------------------------------- GENERAL -------------------------------- */
	title: "Domeinnaam wachtrij",
};

export default domain_queue;
